export interface Book {
  title: string;
  author: string;
  description: string;
  rating: number; // 0 to 5
  publishedYear: string;
}

export interface SearchResult {
  books: Book[];
  sources: string[];
}

export interface BookCheckResult {
  isBestSeller: boolean;
  books: Book[];
  message: string;
  sources: string[];
}

export type Language = 'fa' | 'en';

export enum Genre {
  FICTION = 'Fiction',
  NON_FICTION = 'Non-fiction',
  MYSTERY = 'Mystery',
  THRILLER = 'Thriller',
  ROMANCE = 'Romance',
  SCIFI_FANTASY = 'Science Fiction & Fantasy',
  BIOGRAPHY = 'Biography',
  SELF_HELP = 'Self-Help',
  BUSINESS = 'Business',
  HISTORY = 'History'
}

export const genreLabels: Record<Genre, Record<Language, string>> = {
  [Genre.FICTION]: { fa: 'داستانی (Fiction)', en: 'Fiction' },
  [Genre.NON_FICTION]: { fa: 'غیر داستانی (Non-fiction)', en: 'Non-fiction' },
  [Genre.MYSTERY]: { fa: 'معمایی (Mystery)', en: 'Mystery' },
  [Genre.THRILLER]: { fa: 'هیجان‌انگیز (Thriller)', en: 'Thriller' },
  [Genre.ROMANCE]: { fa: 'عاشقانه (Romance)', en: 'Romance' },
  [Genre.SCIFI_FANTASY]: { fa: 'علمی تخیلی و فانتزی', en: 'Sci-Fi & Fantasy' },
  [Genre.BIOGRAPHY]: { fa: 'بیوگرافی و خاطرات', en: 'Biography & Memoir' },
  [Genre.SELF_HELP]: { fa: 'روانشناسی و خودیاری', en: 'Self-Help' },
  [Genre.BUSINESS]: { fa: 'کسب و کار', en: 'Business' },
  [Genre.HISTORY]: { fa: 'تاریخی', en: 'History' }
};